

import { Component } from "react";
import { Container } from "reactstrap";
import { BankUserContext } from "../bankUserContext";
import CaseTrackerMaster from "../components/CaseManagement/CaseTrackerMaster";


export interface CaseTrackerProps {

}
export default class CaseTrackerPage extends Component< CaseTrackerProps,any>{
  render() {
    return (
      <Container fluid>
        <CaseTrackerMaster disableforsuperuser={false} pathValues={undefined} />
      </Container>
    );
  }
}
